module.exports = __webpack_public_path__ + "80282870295e0683540d2da59f13bec6.mp4";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/testimonials.mp4
// module id = 588
// module chunks = 0